import {sortCaret} from "../../../../_metronic/_helpers";
import * as formatter from "../../../../utils/formatter";
import {SALES_STATUS} from "../../../../utils/codes";
// import {format, subDays} from "date-fns";

export const defaultSorted = [{ dataField: "no", order: "asc" }];

export const salesStatusOptions = SALES_STATUS.map(({key, label}) => ({ key, label }));

export const sizePerPageList = [
  { text: "10개 보기", value: 10 },
  { text: "30개 보기", value: 30 },
  { text: "50개 보기", value: 50 },
  { text: "100개 보기", value: 100 },
];

export const initialFilter = {
  filter: {
    saleNo: "",
    saleSttsCd: "",
    linkNm: "",
    goodsNm: "",
    startDt: "",
    endDt: "",
  },
  sortOrder: "asc",
  sortField: "no",
  pageNumber: 1,
  pageSize: 30,
};

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
    sort: true,
    sortCaret: sortCaret,
  },
  {
    keyField: "no",
    dataField: "saleNo",
    text: "링크 코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "goodsCnt",
    text: "연결 상품 수",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "linkNm",
    text: "링크 이름",
    headerClasses: 'text-center',
    classes: 'text-left',
  },
  {
    keyField: "no",
    dataField: "totSaleAmt",
    text: "총 판매가격",
    headerClasses: 'text-center',
    classes: 'text-right',
    sort: true,
    sortCaret: sortCaret,
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "totOrdCnt",
    text: "누적 주문 건 수",
    headerClasses: 'text-center',
    classes: 'text-center',
    sortCaret: sortCaret,
    formatter: formatter.count,
  },
  {
    keyField: "no",
    dataField: "regDtime",
    text: "판매 등록일",
    sort: true,
    headerClasses: 'text-center',
    classes: 'text-center',
    sortCaret: sortCaret,
    formatter: formatter.date,
  },
  {
    keyField: "no",
    dataField: "saleSttsCd",
    text: "판매 상태",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.dot(SALES_STATUS),
  },
];
